import { Fieldset as MantineFieldset, FieldsetProps } from '@mantine/core';

export type IFieldsetProps = FieldsetProps;

/** @registry Design-layer pass-through over Mantine Fieldset; wrap inputs in one with `disabled` to make a whole region read-only. */
export const Fieldset = MantineFieldset;
